/**
 * The server's clock, as seen from the browser.
 *
 * Whatever compares a timestamp the SERVER wrote with "now" — the signing time inside
 * a presigned S3 link, above all — must not use the PC's clock as is. A machine an hour
 * off (wrong time zone under a "correct" local time is the classic) would judge every
 * link expired while S3, which checks against its own clock, still accepts it.
 *
 * Every API response carries a `Date` header; apiClient hands it here and the offset to
 * the local clock is kept. The header is truncated to the second and arrives after the
 * network round trip, so the estimate can only lag the server a little — a check built
 * on it errs on the side of "still valid".
 */
let offsetMs: number | null = null;

export function noteServerDate(header: unknown, receivedAt: number = Date.now()): void {
  if (typeof header !== "string") return;
  const server = Date.parse(header);
  if (Number.isNaN(server)) return;
  offsetMs = server - receivedAt;
}

/**
 * Server time in epoch ms, or null while no API response has told us the server's
 * clock (none yet, or a cross-origin API that does not expose `Date`).
 */
export function serverNow(): number | null {
  return offsetMs === null ? null : Date.now() + offsetMs;
}

/** Tests only. */
export function resetServerClock(): void {
  offsetMs = null;
}
